export default "__VITE_ASSET__Calew9j___"